import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { authenticatedRoute } from '../_authenticated';

const FormDefinitionFormPage = lazy(() =>
  import('@/features/forms/components/FormDefinitionFormPage').then((m) => ({
    default: m.FormDefinitionFormPage,
  })),
);

function FormNewPage() {
  return (
    <Suspense fallback={<LoadingSpinner label="読み込み中..." />}>
      <FormDefinitionFormPage mode="create" />
    </Suspense>
  );
}

export const formNewRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/forms/new',
  component: FormNewPage,
});
